/**
 * TagChip — small colored pill for a tag. Color falls back to the category
 * color on the server side, so `tag.color` is always usable here.
 */

import React from 'react';
import { contrastText } from './tagApi';

const TagChip = ({ tag, onRemove, size = 'sm', title, style = {} }) => {
  const bg = tag.color || '#6b7280';
  const fg = contrastText(bg);
  const isSm = size === 'sm';
  return (
    <span
      title={title || `${tag.category_name ? `${tag.category_name}: ` : ''}${tag.name}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        backgroundColor: bg,
        color: fg,
        borderRadius: 999,
        padding: isSm ? '1px 8px' : '3px 10px',
        fontSize: isSm ? '0.68rem' : '0.78rem',
        fontWeight: 600,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        maxWidth: 160,
        ...style,
      }}
    >
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{tag.name}</span>
      {onRemove && (
        <button
          onClick={(e) => { e.stopPropagation(); onRemove(tag); }}
          title={`Remove "${tag.name}"`}
          style={{
            background: 'transparent',
            border: 'none',
            color: fg,
            cursor: 'pointer',
            padding: 0,
            fontSize: isSm ? '0.7rem' : '0.8rem',
            lineHeight: 1,
            opacity: 0.75,
          }}
          onMouseEnter={(e) => { e.currentTarget.style.opacity = 1; }}
          onMouseLeave={(e) => { e.currentTarget.style.opacity = 0.75; }}
        >
          ✕
        </button>
      )}
    </span>
  );
};

export default TagChip;
